import React from "react";

/**
 * Suspense fallback for a section or tab's lazy chunk, shown inside the
 * project shell (sidebar already on screen) rather than over it - unlike
 * pages/Loading.js, which covers the whole viewport for page-level loads.
 */
export default function SectionLoading() {
    return (
        <div style={{padding: "40px", textAlign: "center", color: "#999"}}>
            Loading…
        </div>
    );
}
